import { render } from "./WhiteLabelNav.vue?vue&type=template&id=1432ee71"
import script from "./WhiteLabelNav.vue?vue&type=script&lang=js"
export * from "./WhiteLabelNav.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__